exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* BEGIN named global colors */\n/* END named global colors */\n/* BEGIN component colors */\n/* BEGIN shared styles @TODO integrate into the above format*/\n/* END global colors */\n/* BEGIN global colors */\n/* END global colors */\n/* END component colors */\n/* BEGIN fonts */\n/* BEGIN fonts */\n/* BEGIN page widths */\n/* END page widths */\n/* BEGIN px sizes */\n/* END px sizes */\n/* BEGIN transition times */\n/* END transition times */\n/* BEGIN border radius */\n/* END border radius */\n/* BEGIN box shadow */\n/* END box shadow */\n/* BEGIN breakpoints */\n/* END breakpoints */", ""]);

// exports
